import { Modal } from "antd";
import { FC, useMemo, useState } from "react";

import { useLoc, useSchool } from "@app/shared/lib/hooks";

import { useUIAppState } from "../../UIAppStateProvider";

import { EmailChangeForm } from "./EmailChangeForm/EmailChangeForm";
import { EmailConfirmationForm } from "./EmailConfirmationForm/EmailConfirmationForm";

declare type ViewMode = "confirm" | "change";

export const EmailConfirmationBlocker: FC = () => {
  const [viewMode, setViewMode] = useState<ViewMode>("confirm");
  const school = useSchool();
  const loc = useLoc();
  const UIAppState = useUIAppState();
  const closable = useMemo(() => {
    const settings = school.profileSettings;

    return !settings.blockAccessIfEmailUnconfirmed;
  }, [school.profileSettings]);

  const title = useMemo(() => {
    switch (viewMode) {
      case "confirm":
        return loc.word("Email confirmation");
      case "change":
      default:
        return loc.word("Email changing");
    }
  }, []);

  return (
    <Modal
      open
      onCancel={() => UIAppState.setIsEmailConfirmationModalVisible(false)}
      closable={closable}
      maskClosable={closable}
      title={title}
      footer={null}
      width={600}
      destroyOnClose
    >
      {viewMode === "confirm" ? (
        <EmailConfirmationForm
          onEmailChange={() => setViewMode("change")}
          canLogout={!closable}
        />
      ) : (
        <EmailChangeForm
          onEmailChanged={() => setViewMode("confirm")}
          onCancel={() => setViewMode("confirm")}
        />
      )}
    </Modal>
  );
};
